import React from 'react'
import icon from '../icons.svg'
import {localestr,uid} from '../utils.js'

function EditTemplates({Capt,Value,setVal,width1,width2,height2}){

    function read(files) {
      return Promise.all(
        Array.prototype.map.call(files, (file)=> {
          let reader = new FileReader()
          return new Promise((resolve, reject)=> {
              reader.onload = (event)=> resolve({
                name: file.name,
                contents: event.target.result,
              })
              reader.onerror = reject
              reader.readAsDataURL(file)
            })
        })
      )
    }

    function onFilesChange(e){
          read(e.target.files)
          .then((material)=> {
            //console.log(material)
            setVal(material)
          })
                
              
    }

    let cap_but=localestr('Завантажити')
    let cont=null
    const fid=uid()
    if(Value){
        cont=(<>
        <ul>{Value.map((el,idx)=><li key={idx} style={{cursor:'default'}}>{el.name}</li>)}</ul>
        <label htmlFor={fid}>
        <input id={fid} style={{display:'none'}} type="file" multiple onChange={onFilesChange}/>
        <div tabIndex='0' className='toolBarItem' title={localestr('Редагувати')+' (Ins)'}>
            <img src={icon+'#editBut'} alt={localestr('Редагувати')} />
        </div>
        </label>
        <div  tabIndex='0' className='toolBarItem' title={localestr('Видалити')}
            onClick={()=>{setVal(null)}}
            onKeyDown={(e)=>{if(e.key === 'Enter') setVal(null)}}><img src={icon+'#delBut'} alt={localestr('Видалити')} /></div>
        </>)
    } else {
        cont=(
        <label htmlFor={fid}>
            <input id={fid} style={{display:'none'}} type="file" multiple onChange={onFilesChange}/>
            <div style={{width:'110px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{cap_but}</div></div>
        </label>
        )
    }

    return(
        <div style={{display:'inline-flex',flexDirection:'row',margin:'inherit',flexGrow:parseInt(width1)+parseInt(width2),maxWidth:parseInt(width1)*2+parseInt(width2)*2+'px'}}>
            <div style={{display:'inline-flex',minWidth:width1+'px',boxSizing:'border-box',height:'24px',flexBasis:width1+'px',flexGrow:parseInt(width1)/10}}>{Capt}</div>
            <div style={{display:'inline-flex',width:width2+'px',boxSizing:'border-box',flexBasis:width2+'px',flexGrow:parseInt(width2)}}>
            {cont}
            </div>
        </div>
    )
}

export default EditTemplates